// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"571":"30c447c0","670":"59990b84","750":"a140f2bc","824":"9d681107"}[chunkId] + ".chunk.css";
};